import { get } from "lodash";

export const visibleFields = (state, moduleId, relatedModuleId) =>
  get(
    state,
    `modules.relatedModuleVisibleFields[${moduleId}][${relatedModuleId}]`,
    []
  );
